<script setup lang="ts">
import { formatNumberSemiTruncate } from '@/helpers/utils'
import CoinIcon from '@/assets/images/icons/gold-coin-icon.webp'
import mineTutorialBg from '@/assets/images/multiplayer/mine-tutorial-bg.png'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { usePlayer } from '@/composables/game/player'

withDefaults(defineProps<{
  show: boolean
  description?: string
  coinsLost?: number
  attackerName?: string
  attackerAvatarUrl?: string
}>(), {
  description: "You've hit a mine! Your card has been upgraded, but you lost coins to:",
  coinsLost: undefined,
  attackerName: undefined,
  attackerAvatarUrl: undefined,
})

defineEmits<{
  hide: []
}>()

const { goldenCoinValue } = usePlayer()
</script>

<template>
  <TheBottomSheet
    :show="show"
    centered
    content-class="relative bg-transparent p-0"
    wrapper-class="bg-[#FF000070]"
    @hide="$emit('hide')"
  >
    <img :src="mineTutorialBg" class="absolute inset-0 w-full h-full object-cover object-center" alt="">
    <div
      class="absolute inset-0"
      style="background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.02) 79.81%, rgba(0, 0, 0, 0.00) 100%);"
    ></div>
    <div class="relative z-10 flex flex-col items-center w-full pb-8 pt-8 px-6">
      <p
        class="font-pilat font-black text-[32px] leading-[29px] text-white text-center mb-8"
        style="text-shadow: 0px 0px 12px rgba(0,0,0,0.82)"
      >
        BOOM!
      </p>

      <p class="text-solid-white text-base font-semibold text-center mb-3">
        {{ description }}
      </p>

      <div v-if="attackerName" class="flex flex-col items-center gap-1 mb-8">
        <div v-if="attackerAvatarUrl" class="w-12 h-12 rounded-full overflow-hidden shrink-0">
          <img :src="attackerAvatarUrl" class="w-full h-full object-cover" alt="attacker">
        </div>
        <div v-else class="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center shrink-0 text-white font-bold text-lg">
          {{ attackerName.charAt(0).toUpperCase() }}
        </div>
        <span class="text-white font-semibold text-base">{{ attackerName }}</span>
      </div>

      <div v-if="coinsLost" class="w-full flex flex-col items-center justify-center gap-2 bg-white/10 border border-white/20 rounded-[28px] px-4 py-3 mb-8">
        <img :src="CoinIcon" class="w-auto h-[55px] object-contain shrink-0" alt="coin">
        <span class="coins-amount font-bold text-[28px] leading-[38px] -mt-6">
          -{{ formatNumberSemiTruncate(coinsLost*goldenCoinValue) }}
        </span>
      </div>

      <BaseButton class="w-full" @click="$emit('hide')">
        CLOSE
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped lang="scss">
.coins-amount {
  color: #10F;
  text-align: center;
  text-shadow: 0 0 22.39px #10F;
  -webkit-text-stroke-width: 4px;
  -webkit-text-stroke-color: #36EEFF;
  paint-order: stroke fill;
}
</style>
